import api from './api';

export const sampleReceiveService = {
  // Search collected and accessioned samples with multi-criteria filtering
  searchSamples: async (params = {}) => {
    const response = await api.get('/sample-receive/search', { params });
    return response.data;
  },

  // Get Accessioning counter metrics for workbench dashboard
  getSummary: async (params = {}) => {
    const response = await api.get('/sample-receive/summary', { params });
    return response.data;
  },

  // Get list of active rejection reasons
  getRejectionReasons: async () => {
    const response = await api.get('/sample-receive/rejection-reasons');
    return response.data;
  },

  // Retrieve detail of a specific specimen test item
  getSampleById: async (testId) => {
    const response = await api.get(`/sample-receive/${testId}`);
    return response.data;
  },

  // Accept/receive one or more specimen tubes
  receiveSamples: async (data) => {
    const response = await api.post('/sample-receive/receive', data);
    return response.data;
  },

  // Reject one or more specimen tubes with reason
  rejectSamples: async (data) => {
    const response = await api.post('/sample-receive/reject', data);
    return response.data;
  },

  // Get all reference lab options for a given test (multi-lab outsource routing)
  getLabsForTest: async (testId) => {
    const response = await api.get(`/sample-receive/labs-for-test/${testId}`);
    return response.data;
  },

  // Assign a specific reference lab to an outsource test
  assignOutsourceLab: async (data) => {
    const response = await api.post('/sample-receive/assign-outsource-lab', data);
    return response.data;
  },
};

export default sampleReceiveService;
